/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ step: NonNullable<unknown> }} Portals_Wizard_StepInputs */

const cs_portals_wizard_step = /** @type {(inputs: Portals_Wizard_StepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Krok ${i?.step} ze 3`)
};

const en_portals_wizard_step = /** @type {(inputs: Portals_Wizard_StepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Step ${i?.step} of 3`)
};

/**
* | output |
* | --- |
* | "Step {step} of 3" |
*
* @param {Portals_Wizard_StepInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_wizard_step = /** @type {((inputs: Portals_Wizard_StepInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Wizard_StepInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_wizard_step(inputs)
	return cs_portals_wizard_step(inputs)
});